// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logs-content {
  max-width: 1400px;
}

/* ── Date range fetch bar ── */
.logs-filter-bar {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.logs-date-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.logs-label {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.logs-date-input {
  width: 160px;
  padding: 8px 10px;
  font-size: 14px;
}

.logs-fetch-btn,
.logs-export-btn {
  height: 38px;
  padding: 0 20px;
  white-space: nowrap;
}

/* ── Column filters bar ── */
.logs-column-filters {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 14px 20px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.logs-filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.logs-filter-group--actions {
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.logs-search-input {
  width: 220px;
  padding: 8px 12px;
  font-size: 14px;
}

.logs-filter-select {
  width: 140px;
  padding: 8px 10px;
  font-size: 14px;
}

.logs-filter-select--wide {
  width: 200px;
}

.logs-reset-btn {
  height: 36px;
  padding: 0 14px;
  font-size: 13px;
  white-space: nowrap;
}

.logs-count {
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
}

/* ── Error ── */
.logs-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 16px;
}

/* ── Loading state ── */
.logs-state-msg {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  padding: 40px 0;
  color: #64748b;
  font-size: 15px;
}

.logs-spinner {
  width: 22px;
  height: 22px;
  border: 3px solid #e2e8f0;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: logs-spin 0.7s linear infinite;
}

@keyframes logs-spin {
  to { transform: rotate(360deg); }
}

/* ── Empty state ── */
.logs-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  color: #94a3b8;
  text-align: center;
}

.logs-empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.logs-empty-state p {
  font-size: 15px;
  max-width: 360px;
}

/* ── Table ── */
.logs-table-wrap {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: auto;
}

.logs-table {
  font-size: 13px;
  min-width: 960px;
}

.logs-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
  white-space: nowrap;
}

.logs-th-num,
.logs-td-num {
  width: 48px;
  text-align: center;
  color: #94a3b8;
  font-size: 12px;
}

.logs-td-ts {
  white-space: nowrap;
  color: #475569;
  font-size: 12px;
  min-width: 160px;
}

.logs-td-module {
  white-space: nowrap;
  font-weight: 600;
  color: #1e40af;
  min-width: 160px;
}

.logs-td-program {
  white-space: nowrap;
  color: #64748b;
  font-size: 12px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logs-td-user {
  white-space: nowrap;
  font-size: 12px;
  color: #334155;
  min-width: 140px;
}

.logs-td-type {
  white-space: nowrap;
}

.logs-td-content {
  max-width: 420px;
  word-break: break-word;
  color: #1a202c;
}

/* Error row highlight */
.log-row-error {
  background: #fff5f5 !important;
}

.log-row-error:hover {
  background: #fef2f2 !important;
}

/* ── Type badges ── */
.log-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.log-badge.success {
  background: #dcfce7;
  color: #15803d;
}

.log-badge.error {
  background: #fee2e2;
  color: #dc2626;
}

.log-badge.info {
  background: #dbeafe;
  color: #1d4ed8;
}

.log-badge.page {
  background: #ede9fe;
  color: #7c3aed;
}

.log-badge.warning {
  background: #fef3c7;
  color: #b45309;
}

.log-badge.default {
  background: #f1f5f9;
  color: #64748b;
}

/* ── Pagination ── */
.logs-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
  padding: 10px 4px;
}

.logs-page-size {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logs-page-size-select {
  width: 80px;
  padding: 6px 8px;
  font-size: 13px;
}

.logs-page-nav {
  display: flex;
  align-items: center;
  gap: 6px;
}

.logs-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.logs-page-btn:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.logs-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.logs-page-info {
  font-size: 13px;
  color: #64748b;
  min-width: 120px;
  text-align: center;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .logs-filter-bar,
  .logs-column-filters {
    flex-direction: column;
    align-items: stretch;
    padding: 12px;
    gap: 12px;
  }

  .logs-date-input,
  .logs-search-input,
  .logs-filter-select,
  .logs-filter-select--wide {
    width: 100%;
  }

  .logs-fetch-btn,
  .logs-export-btn,
  .logs-reset-btn {
    width: 100%;
  }

  .logs-filter-group--actions {
    margin-left: 0;
    flex-wrap: wrap;
    width: 100%;
  }

  .logs-count {
    margin-left: 0;
  }

  .logs-table-wrap {
    max-height: none;
    -webkit-overflow-scrolling: touch;
  }

  .logs-pagination {
    flex-direction: column;
    align-items: stretch;
  }

  .logs-page-nav {
    justify-content: center;
    width: 100%;
  }

  .logs-page-size {
    width: 100%;
    justify-content: space-between;
  }
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .logs-filter-bar,
[data-theme="dark"] .logs-column-filters {
  background: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .logs-label,
[data-theme="dark"] .logs-count,
[data-theme="dark"] .logs-state-msg,
[data-theme="dark"] .logs-page-info {
  color: var(--text-muted);
}
[data-theme="dark"] .logs-table th {
  background: var(--surface-2);
}
[data-theme="dark"] .logs-td-ts,
[data-theme="dark"] .logs-td-program,
[data-theme="dark"] .logs-td-user {
  color: var(--text-muted);
}
[data-theme="dark"] .logs-td-content {
  color: var(--text);
}
[data-theme="dark"] .logs-td-module {
  color: var(--primary);
}
[data-theme="dark"] .logs-page-btn {
  background: var(--surface);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .logs-page-btn:hover:not(:disabled) {
  background: var(--surface-hover);
  border-color: var(--border-strong);
}
[data-theme="dark"] .log-row-error {
  background: rgba(220, 38, 38, 0.14) !important;
}
[data-theme="dark"] .log-row-error:hover {
  background: rgba(220, 38, 38, 0.22) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Logs/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE;;IAEE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,SAAS;EACX;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA,4DAA4D;AAC5D;;EAEE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;;;EAIE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD","sourcesContent":[".logs-content {\n  max-width: 1400px;\n}\n\n/* ── Date range fetch bar ── */\n.logs-filter-bar {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  padding: 16px 20px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.logs-date-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.logs-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.logs-date-input {\n  width: 160px;\n  padding: 8px 10px;\n  font-size: 14px;\n}\n\n.logs-fetch-btn,\n.logs-export-btn {\n  height: 38px;\n  padding: 0 20px;\n  white-space: nowrap;\n}\n\n/* ── Column filters bar ── */\n.logs-column-filters {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  padding: 14px 20px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.logs-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.logs-filter-group--actions {\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  margin-left: auto;\n}\n\n.logs-search-input {\n  width: 220px;\n  padding: 8px 12px;\n  font-size: 14px;\n}\n\n.logs-filter-select {\n  width: 140px;\n  padding: 8px 10px;\n  font-size: 14px;\n}\n\n.logs-filter-select--wide {\n  width: 200px;\n}\n\n.logs-reset-btn {\n  height: 36px;\n  padding: 0 14px;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.logs-count {\n  font-size: 13px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n/* ── Error ── */\n.logs-error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n/* ── Loading state ── */\n.logs-state-msg {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: center;\n  padding: 40px 0;\n  color: #64748b;\n  font-size: 15px;\n}\n\n.logs-spinner {\n  width: 22px;\n  height: 22px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  animation: logs-spin 0.7s linear infinite;\n}\n\n@keyframes logs-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Empty state ── */\n.logs-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 24px;\n  color: #94a3b8;\n  text-align: center;\n}\n\n.logs-empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.6;\n}\n\n.logs-empty-state p {\n  font-size: 15px;\n  max-width: 360px;\n}\n\n/* ── Table ── */\n.logs-table-wrap {\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.logs-table {\n  font-size: 13px;\n  min-width: 960px;\n}\n\n.logs-table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n  white-space: nowrap;\n}\n\n.logs-th-num,\n.logs-td-num {\n  width: 48px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.logs-td-ts {\n  white-space: nowrap;\n  color: #475569;\n  font-size: 12px;\n  min-width: 160px;\n}\n\n.logs-td-module {\n  white-space: nowrap;\n  font-weight: 600;\n  color: #1e40af;\n  min-width: 160px;\n}\n\n.logs-td-program {\n  white-space: nowrap;\n  color: #64748b;\n  font-size: 12px;\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.logs-td-user {\n  white-space: nowrap;\n  font-size: 12px;\n  color: #334155;\n  min-width: 140px;\n}\n\n.logs-td-type {\n  white-space: nowrap;\n}\n\n.logs-td-content {\n  max-width: 420px;\n  word-break: break-word;\n  color: #1a202c;\n}\n\n/* Error row highlight */\n.log-row-error {\n  background: #fff5f5 !important;\n}\n\n.log-row-error:hover {\n  background: #fef2f2 !important;\n}\n\n/* ── Type badges ── */\n.log-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.log-badge.success {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.log-badge.error {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.log-badge.info {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.log-badge.page {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.log-badge.warning {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.log-badge.default {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n/* ── Pagination ── */\n.logs-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 12px;\n  padding: 10px 4px;\n}\n\n.logs-page-size {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.logs-page-size-select {\n  width: 80px;\n  padding: 6px 8px;\n  font-size: 13px;\n}\n\n.logs-page-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.logs-page-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  color: #374151;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.logs-page-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.logs-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.logs-page-info {\n  font-size: 13px;\n  color: #64748b;\n  min-width: 120px;\n  text-align: center;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .logs-filter-bar,\n  .logs-column-filters {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 12px;\n    gap: 12px;\n  }\n\n  .logs-date-input,\n  .logs-search-input,\n  .logs-filter-select,\n  .logs-filter-select--wide {\n    width: 100%;\n  }\n\n  .logs-fetch-btn,\n  .logs-export-btn,\n  .logs-reset-btn {\n    width: 100%;\n  }\n\n  .logs-filter-group--actions {\n    margin-left: 0;\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .logs-count {\n    margin-left: 0;\n  }\n\n  .logs-table-wrap {\n    max-height: none;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .logs-pagination {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .logs-page-nav {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .logs-page-size {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .logs-filter-bar,\n[data-theme=\"dark\"] .logs-column-filters {\n  background: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .logs-label,\n[data-theme=\"dark\"] .logs-count,\n[data-theme=\"dark\"] .logs-state-msg,\n[data-theme=\"dark\"] .logs-page-info {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .logs-table th {\n  background: var(--surface-2);\n}\n[data-theme=\"dark\"] .logs-td-ts,\n[data-theme=\"dark\"] .logs-td-program,\n[data-theme=\"dark\"] .logs-td-user {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .logs-td-content {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .logs-td-module {\n  color: var(--primary);\n}\n[data-theme=\"dark\"] .logs-page-btn {\n  background: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .logs-page-btn:hover:not(:disabled) {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n}\n[data-theme=\"dark\"] .log-row-error {\n  background: rgba(220, 38, 38, 0.14) !important;\n}\n[data-theme=\"dark\"] .log-row-error:hover {\n  background: rgba(220, 38, 38, 0.22) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
